/*
 * File: ProductMasterCards.tsx
 * Project: amazing-mumford
 * -----
 * Last Modified: 30 Dec 2020 5:14:41 pm
 * -----
 * Copyright (c) 2020 Elegant Software Solutions All rights reserved.
 */
import { Col, Row } from 'antd';
import { Loader } from 'components/atoms/Loader';
import NoResults from 'components/atoms/noResults/noResults';
import { POReceiptCard } from 'components/molecules/POReceiptCard';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { useGetPurchaseOrdersQuery } from 'redux/services/grannyBird/grannyBirdApi';
import { setOffset } from 'redux/services/grannyBird/poReceiptParams';
import { ReduxState } from 'redux/store';

const styles: InlineStylesModel = {
  defaultCursor: {
    cursor: 'pointer'
  },
  infiniteScroll: {
    overflow: 'none'
  },
  noResults: {
    fontWeight: 600,
    paddingTop: '2rem'
  }
};

export const POReceiptCards = (): JSX.Element => {
  const { grannyBirdParams } = useSelector((state: ReduxState) => state);

  const { offset } = useSelector((state: ReduxState) => state.grannyBirdParams);

  const { data: poReceipts, isLoading: isLoadingPOReceipts, isFetching } = useGetPurchaseOrdersQuery({ params: grannyBirdParams });

  const dispatch = useDispatch();

  const requestMoreCards = (): void => {
    dispatch(setOffset());
  };

  // const cardsSource = !currentlyFiltering ? POReceiptList : POReceiptListFiltered;
  const allCardsJSX = poReceipts?.data.map((value, index) => {
    return (
      <Col style={styles.defaultCursor} key={`${value}-${index}`} sm={12} lg={8} xl={6} xxl={6}>
        <POReceiptCard
          createdDateTime={value.createdDateTime}
          deliveryMode={value.deliveryMode}
          directDelivery={value.directDelivery}
          lines={value.lines}
          orderedBy={value.orderedBy}
          purchaseOrderNumber={value.purchaseOrderNumber}
          requestedBy={value.requestedBy}
          vendorAccount={value.vendorAccount}
          vendorName={value.vendorName}
          vendorOrderReference={value.vendorOrderReference}
          warehouse={value.warehouse}
        />
      </Col>
    );
  });

  if ((isLoadingPOReceipts || isFetching) && offset === 0)
    return (
      <Row style={{ marginTop: 50 }}>
        <Loader />
      </Row>
    );

  if (!poReceipts?.data.length && (!isLoadingPOReceipts || !isFetching))
    return (
      <Row justify="center" style={styles.errorMessage}>
        <NoResults errorMessage="No Results Found" />
      </Row>
    );

  return (
    <InfiniteScroll
      dataLength={poReceipts?.data.length ?? 0}
      hasMore={Boolean(poReceipts && poReceipts.totalCount > poReceipts.data.length)}
      loader={
        <Row style={{ marginTop: 50 }}>
          <Loader />
        </Row>
      }
      next={requestMoreCards}
      style={styles.infiniteScroll}>
      <Row gutter={[16, 16]}>{allCardsJSX}</Row>
    </InfiniteScroll>
  );
};
